import * as React from "react";
import { Button } from "semantic-ui-react";

import { MedicalType } from "@teamprevent/common/healthSurveillance/models";

import { PartialOhCaseDetailModel } from "../../crud/ohCase";

import { AddMultipleTasksModal } from "./AddMultipleTasksModal";

type Props = {
    customerId: string;
    ohCase: PartialOhCaseDetailModel;
    medicalTypes: MedicalType[];
    caseType?: string;
}

export const AddTasks: React.FunctionComponent<Props> = (props) => {
    const [open, setOpen] = React.useState(false);

    const onOpen = React.useCallback(() => setOpen(true),[]);
    const onClose = React.useCallback(() => setOpen(false),[]);

    return (
        <>
            {open &&
                <AddMultipleTasksModal
                    open={open}
                    onClose={onClose}
                    customerId={props.customerId}
                    ohCase={props.ohCase}
                    medicalTypes={props.medicalTypes}
                    caseType={props.caseType}
                    assignmentOptionRequired={true}
                />
            }
            <Button
                icon="add"
                content="Add Tasks"
                onClick={onOpen}
            />
        </>
    );
};
